import React from 'react'
import PageHeader from '../../components/pageHeader/PageHeader'

const Faq = () => {
  return (
    <div>
       <PageHeader title={'FAQ'}/>
       <h1>FAQ</h1>
    </div>
  )
}

export default Faq

